import { FadeBetweenContainer } from "@builder/components/general/FadeBetweenContainer/FadeBetweenContainer";
import OliverText from "@builder/components/general/OliverText";
import { AnimatedThreeDots } from "@builder/components/onboard/components/smallComponents/AnimatedThreeDots";
import ThinkingBackground from "@builder/components/onboard/components/thinkingUI/ThinkingBackground";
import { useEffect, useRef } from "react";
import SlideUp from "../slidingElements/SlideUp";
import "./styles.scss";
import { onboardStepsToShow } from "./temporary_fake_activities";

const ThatsFinalAndClose = ({ closeOnboard }: { closeOnboard: () => void }) => {
   
    const FIRST_ANIMATION_DURATION = 2500;
    const SECOND_ANIMATION_DURATION = 2000;
    const TIME_BETWEEN_ELEMENTS = 500;

    useEffect(() => {
        if (closeOnboard) {
            setTimeout(() => {
                closeOnboard();
                // start mid second animation
            }, FIRST_ANIMATION_DURATION + TIME_BETWEEN_ELEMENTS + SECOND_ANIMATION_DURATION /1.5);
        }
    }, [closeOnboard]);

    return (
        <div className="done-text" key="gif">
            <div className="thats-final" style={{ "--first-animation-duration": `${FIRST_ANIMATION_DURATION}ms`, "--second-animation-duration": `${SECOND_ANIMATION_DURATION}ms`, "--time-between-elements": `${TIME_BETWEEN_ELEMENTS}ms` } as React.CSSProperties}>
                <div className="show-animation-1">
                    <div className="checkmark-once-gif-wrapper">
                    <img src={`/checkmark-once.gif`} alt="thats-final"/>
                    </div>
                </div>
                <div className="show-animation-2">
                    <OliverText text="and that's Final!" color="white" size="xl"/>
                </div>
            </div>
        </div>
    );
};

const OnboardActivityTexts = ({
    currentActions,
    isDone,
    closeOnboard
}: {
    currentActions: onboardStepsToShow[];
    isDone: boolean;
    closeOnboard: () => void;
}) => {
    const DELAY_BEFORE_IS_FINAL = 1500;
    const delayedIsDoneRef = useRef(isDone);
    useEffect(() => {
        const timeout = setTimeout(() => {
            delayedIsDoneRef.current = isDone;
        }, DELAY_BEFORE_IS_FINAL);
        return () => clearTimeout(timeout);
    }, [isDone]);

    return (
        <ThinkingBackground className="onboard-creation-texts" speed={3}>
            <div className="texts-container">
                    <FadeBetweenContainer options={{ fadeDuration: 200, timeInBetween: 500 }}>
                        {delayedIsDoneRef.current ? (
                            <ThatsFinalAndClose closeOnboard={closeOnboard} key="thats-final-and-close" />
                    ) : (
                            <SlideUp
                                key="sliding-elements"
                                items={currentActions.map((step, idx) => {
                                    const currentRunningOne = idx === currentActions.length - 1;
                                    return (
                                        {id: step.id, element: (
                                        <div key={step.id} className="activity">
                                            <AnimatedThreeDots
                                                text={currentRunningOne ? step.present : step.past}
                                                numDots={3}
                                                numToFreeze={3}
                                                textClassName="activity-text"
                                                style={{ color: currentRunningOne && !delayedIsDoneRef.current ? "#fff" : "#ffffff99" }}
                                            />
                                        </div>
                                        )}
                                    );
                                })}
                                options={{ maxVisibleItems: 5, gap: 24 }}
                            />
                        )}
                    </FadeBetweenContainer>
            </div>
        </ThinkingBackground>
    );
};

export default OnboardActivityTexts;
